import { createRoot } from 'react-dom/client';

import './config/i18n';
import './scss/application.scss';
import App from './app';

const root = createRoot(document.getElementById('root'));
root.render(<App />);
